import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PortalComponent } from 'src/app/areas/oa/views/portal/portal.component';
import { Subject } from 'rxjs';

@Injectable()
export class SwUnfocusGuardService  implements CanDeactivate<PortalComponent>{

  //路由跳转时,侧边菜单刷新成对应模块的菜单
  asideMenuUpdated: Subject<any> = new Subject<any>();
  canDeactivate(component: PortalComponent,route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //当从 protal 页面离开的时候会触发此方法
    let path = "";
    for (let i = 0; route["_urlSegment"].segments.length > i; i++) {
      if (route["_urlSegment"].segments[i].path!="" ) {
        path = path + "/" +route["_urlSegment"].segments[i].path
      }
    }
    this.asideMenuUpdated.next(path)
    return true;
  }
  constructor(
  ) { }
} 
